import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Data } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

import { EBillFinanceActions, fromEBillFinance } from '@ruby/modules/ebill/store/ebill-finance.index';
import { selectBillFinanceState } from '@ruby/modules/ebill/store/selectors/ebill-finance.selectors';
import { ITransaction } from '@ruby/shared/models/commons/transaction.interface';
import { IEBillInvoiceSummary } from '@ruby/shared/models/ebill/ebil.interface';

@Component({
  selector: 'ng-ebill-finance-container',
  template: `
    <ng-ebill-finance *ngIf="(store$ | async) as store"
                      [data]="store.financeDetails"
                      [bill]="bill"
                      [loading]="store.loading"
                      [isDownloading]="store.isDownloading"
                      (downloadExcel)="dispatchDownloadExcel()"
                      (refreshGrid)="load()"
    >
    </ng-ebill-finance>
  `
})
export class EBillFinanceContainer implements OnDestroy {
  store$!: Observable<fromEBillFinance.State>;
  bill!: Partial<IEBillInvoiceSummary>;
  private acrSubscription!: Subscription;

  constructor(private store: Store<fromEBillFinance.State>, private acr: ActivatedRoute) {
    this.store$ = store.select(selectBillFinanceState);
    this.parseTransaction();
  }

  ngOnDestroy(): void {
    this.acrSubscription.unsubscribe();
  }

  /**
   * Dispatch Download Excel Action
   *
   * @summary dispatch download Excel Action
   * @returns void
   */
  dispatchDownloadExcel(): void {
    this.store.dispatch(EBillFinanceActions.downloadExcel({ data: this.bill }));
  }

  /**
   * Load
   *
   * @summary Load Data
   * @returns void
   */
  load(): void {
    this.store.dispatch(EBillFinanceActions.loadDetails({ data: this.bill }));
  }

  private parseTransaction(): void {
    this.acrSubscription = this.acr.data.pipe(
      map((data: Data) => data.transaction)
    ).subscribe((transaction: ITransaction) => {
      if (transaction) {
        this.bill = JSON.parse(transaction.parameters.eBill!) as Partial<IEBillInvoiceSummary>;
        this.load();
      }
    });
  }
}
